'use client';
import ButtonBase from '@mui/material/ButtonBase';
import {styled, type SxProps, type Theme} from '@mui/material/styles';
import type {ReactNode} from 'react';

export interface FullscreenButtonProps {
  children: ReactNode;
  onClick?: () => void;
  'aria-label'?: string;
  sx?: SxProps<Theme>;
  className?: string;
}

// Bordered, raised corner control (Figma "Signs": 5px pad, 8px radius) — the
// white affordance pinned to a media frame's corner that opens the lightbox.
// Position is the caller's concern (absolute in FloorPlanViewer's frame, an
// in-flow flex child in MediaGallery's) — this only owns the button's chrome.
const Root = styled(ButtonBase)(({theme}) => ({
  padding: 5,
  borderRadius: theme.radii.xs,
  border: `1px solid ${theme.palette.colors.border.neutral.subtle}`,
  backgroundColor: theme.palette.colors.surface.neutral.default,
  color: theme.palette.colors.icon.neutral.strong,
  '&:focus-visible': {outline: `2px solid ${theme.palette.colors.border.focus.default}`, outlineOffset: 2},
}));

export function FullscreenButton({children, sx, ...rest}: FullscreenButtonProps) {
  return (
    <Root type="button" sx={sx} {...rest}>
      {children}
    </Root>
  );
}

FullscreenButton.displayName = 'FullscreenButton';
